var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheGauche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.456 17.403c-.182.135-1.915 1.835-3.852 3.778-3.274 3.285-3.521 3.552-3.521 3.819 0 .267.25.538 3.605 3.898 1.982 1.986 3.723 3.685 3.869 3.776.322.201.625.148.861-.153.394-.501.428-.457-2.895-3.787l-3.06-3.067h9.509c9.071 0 9.518-.007 9.697-.152.265-.215.265-.815 0-1.03-.179-.145-.626-.152-9.697-.152h-9.509l3.06-3.067c2.864-2.87 3.06-3.086 3.06-3.36 0-.328-.236-.609-.585-.696-.156-.039-.296.011-.542.193",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheGauche);
export default __webpack_public_path__ + "static/media/fleche-gauche.e8122a7568bbf2887f13862301602f8b.svg";
export { ForwardRef as ReactComponent };